import {DynamicDataTableFilterFilterOption} from "./types";
import {FancyAutocompleteOption} from "../data/auto-complete/types";

export function transformToStringTuples(options: {[value: string]: DynamicDataTableFilterFilterOption} | [string, DynamicDataTableFilterFilterOption][]): [string,string][] {
  const normalizedOptions = normalizeOptions(options)
  return normalizedOptions.map((optionTuple): [string, string] => {
    if (typeof optionTuple[1] === 'string') {
      return optionTuple as [string, string]
    }
    return [optionTuple[0], optionTuple[1].text + (optionTuple[1].subText ? ` (${optionTuple[1].subText})` : '')]
  })
}

export function transformToStringMapObject(options: {[value: string]: DynamicDataTableFilterFilterOption} | [string, DynamicDataTableFilterFilterOption][]): {[value: string]: string} {
  const normalizedOptions = normalizeOptions(options)
  const entries = normalizedOptions.map((optionTuple): [string, string] => {
    if (typeof optionTuple[1] === 'string') {
      return optionTuple as [string, string]
    }
    return [optionTuple[0], optionTuple[1].text + (optionTuple[1].subText ? ` (${optionTuple[1].subText})` : '')]
  })
  return Object.fromEntries(entries)
}

export function transformToFancyAutocompleteOptions(options: {[value: string]: DynamicDataTableFilterFilterOption} | [string, DynamicDataTableFilterFilterOption][]): FancyAutocompleteOption[] {
  const normalizedOptions = normalizeOptions(options)
  return normalizedOptions.map((optionTuple): FancyAutocompleteOption => {
    if (typeof optionTuple[1] === 'string') {
      return {
        key: optionTuple[0],
        text: optionTuple[1],
      }
    }
    return {
      key: optionTuple[0],
      text: optionTuple[1].text,
      subText: optionTuple[1].subText,
    }
  })
}

function normalizeOptions(options: {[value: string]: DynamicDataTableFilterFilterOption} | [string, DynamicDataTableFilterFilterOption][]): [string,DynamicDataTableFilterFilterOption][] {
  let optionsArray: [string, DynamicDataTableFilterFilterOption][]
  if (Array.isArray(options)) {
    optionsArray = options
  }  else {
    optionsArray = Object.entries(options)
  }
  return optionsArray
}
